import { format as formatDate } from 'date-fns';
import {
  selectDaysInAdvance,
  selectItineraryDates,
  selectOriginDestinationCodes,
  selectTripDuration,
} from '@/selectors';

const yyyymmddFormat = 'yyyy-MM-dd';
const ddmmyyyyFormat = 'dd-MM-yyyy';

function dataLayerUpdater({ itinerary, isPrime }, saveDatalayer) {
  saveDatalayer({
    product: 'PRICE_FREEZE_FLIGHT',
    product_code: 'PFFI',
    product_id: selectOriginDestinationCodes(itinerary),
    user_prime_subscription: isPrime ? 'subscriber' : 'non-subscriber',
  });
}

// todo: enable when localStorage fix agreed
// eslint-disable-next-line no-unused-vars
function customDimensionsUpdater({ itinerary, offer, searchCriteria, sbId }) {
  const [arrivalDate, departureDate] = selectItineraryDates(itinerary);
  return {
    dimension2: formatDate(Date.parse(departureDate), yyyymmddFormat),
    dimension3: formatDate(Date.parse(arrivalDate), yyyymmddFormat),
    dimension5: 'PFFI',
    dimension6: selectOriginDestinationCodes(itinerary),
    dimension43: itinerary.tripType,
    dimension44: `d:${formatDate(
      Date.parse(departureDate),
      ddmmyyyyFormat
    )}_r:${formatDate(Date.parse(arrivalDate), ddmmyyyyFormat)}`,
    dimension54: offer.deposit.amount,
    dimension57: sbId,
    dimension68: 'flight',
    metric1: searchCriteria.pax.numAdults + searchCriteria.pax.numChildren,
    metric2: searchCriteria.pax.numAdults,
    metric3: searchCriteria.pax.numChildren,
    metric4: searchCriteria.pax.numChildren,
    metric5: selectTripDuration(itinerary),
    metric7: selectDaysInAdvance(itinerary),
  };
}
export const funnelContextDatalayerUpdater = {
  update(data = {}, saveDatalayer) {
    dataLayerUpdater(data, saveDatalayer);
  },
};
export const funnelContextCustomDimensionUpdater = {
  update() {},
};
